import { Link } from 'react-router-dom';
import { categories } from '@/utils/articles';

export default function SiteIntro() {
  return (
    <section className="rounded-lg border border-background-200 bg-secondary-100 p-6 md:p-8">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <h2 className="flex items-center gap-2 text-xl font-black text-foreground-950">
            <i className="ri-shield-star-line text-primary-500"></i>
            关于 91黑料网
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            91黑料网是一个聚焦于 <strong className="text-foreground-900">最新娱乐黑料、明星爆料与社会热点新闻</strong> 的资讯聚合平台。我们通过全网信息收集与编辑整理，
            用清晰的时间线与分类结构，帮助你在碎片化时间里快速掌握正在发酵的话题与爆料。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            网站内容每日 07:00 至 24:00 持续更新，涵盖三大核心频道，并提供标签聚合、热门排行、收藏与分享等功能，
            让你不仅能看，还能把值得关注的内容留住、传出去。
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="flex cursor-pointer items-center gap-1 rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                <i className={c.icon}></i>
                {c.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 lg:grid-cols-1 lg:gap-4">
          <div className="rounded-lg bg-background-50 p-4">
            <p className="font-label text-2xl font-bold text-primary-600">24H</p>
            <p className="mt-1 text-xs text-foreground-500">全时段滚动更新</p>
          </div>
          <div className="rounded-lg bg-background-50 p-4">
            <p className="font-label text-2xl font-bold text-accent-500">3+</p>
            <p className="mt-1 text-xs text-foreground-500">核心爆料频道</p>
          </div>
          <div className="rounded-lg bg-background-50 p-4">
            <p className="font-label text-2xl font-bold text-foreground-950">15+</p>
            <p className="mt-1 text-xs text-foreground-500">高频热点标签</p>
          </div>
        </div>
      </div>
    </section>
  );
}